export const quotesLogosRoutes = { logos: { proxy: 'quotes/logos', upstream: 'v2/logos/search' } } as const;
